
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../util/api";

const AdminSidebar = ({
    sidebarOpen,
    setSidebarOpen,
}) => {

    const location = useLocation();
    const {logout} = useContext(AuthContext);
    const navigate = useNavigate();


    const menuGroups = [

        {
            title: "MAIN",
            items: [
                {
                    label: "Dashboard",
                    path: "/admin",
                    icon: "▦",
                },
            ],
        },


        {
            title: "WEBSITE",
            items: [
                {
                    label: "Profile",
                    path: "/admin/profile",
                    icon: "◉",
                },
                {
                    label: "About",
                    path: "/admin/about",
                    icon: "▤",
                },
                {
                    label: "Current Office",
                    path: "/admin/office",
                    icon: "⌂",
                },
                {
                    label: "Career & Timeline",
                    path: "/admin/career",
                    icon: "◷",
                },
                {
                    label: "Constituency",
                    path: "/admin/constituency",
                    icon: "⌖",
                },
                {
                    label: "Impact",
                    path: "/admin/impact",
                    icon: "↗",
                },
                {
                    label: "Projects",
                    path: "/admin/projects",
                    icon: "▧",
                },
                {
                    label: "News",
                    path: "/admin/news",
                    icon: "▥",
                },
                {
                    label: "Media Library",
                    path: "/admin/media",
                    icon: "▣",
                },
            ],
        },


  /*       {
            title: "COMMUNICATION",
            items: [
                {
                    label: "Messages",
                    path: "/admin/messages",
                    icon: "✉",
                },
                {
                    label: "Newsletter",
                    path: "/admin/newsletter",
                    icon: "♢",
                },
            ],
        }, */


        {
            title: "SYSTEM",
            items: [
                {
                    label: "Users",
                    path: "/admin/users",
                    icon: "♙",
                },
               /*  {
                    label: "Activity Logs",
                    path: "/admin/activity",
                    icon: "◴",
                }, */
             /*    {
                    label: "Site Settings",
                    path: "/admin/settings",
                    icon: "⚙",
                }, */
            ],
        },

    ];


    const isActive = (path) => {

        if (path === "/admin") {
            return location.pathname === "/admin";
        }

        return location.pathname.startsWith(path);
    };


    return (
        <aside
            className={`admin-sidebar ${
                sidebarOpen
                    ? "open"
                    : ""
            }`}
        >

            {/* =========================================
                LOGO
            ========================================= */}

            <div className="admin-logo">

                <div className="admin-logo-mark">
                    A
                </div>

                <div>

                    <strong>
                        ADMIN
                    </strong>

                    <span>
                        Official Website
                    </span>

                </div>

            </div>


            {/* =========================================
                CLOSE MOBILE SIDEBAR
            ========================================= */}

            <button
                className="admin-sidebar-close"
                type="button"
                onClick={() =>
                    setSidebarOpen(false)
                }
            >
                ×
            </button>


            {/* =========================================
                NAVIGATION
            ========================================= */}

            <div className="admin-sidebar-scroll">

                {menuGroups.map(
                    (group, groupIndex) => (

                        <div
                            className="admin-menu-group"
                            key={groupIndex}
                        >

                            <div className="admin-menu-title">
                                {group.title}
                            </div>


                            <nav>

                                {group.items.map(
                                    (item) => (

                                        <Link
                                            key={item.path}
                                            to={item.path}
                                            onClick={() =>
                                                setSidebarOpen(
                                                    false
                                                )
                                            }
                                            className={
                                                isActive(
                                                    item.path
                                                )
                                                    ? "active"
                                                    : ""
                                            }
                                        >

                                            <span className="admin-menu-icon">
                                                {item.icon}
                                            </span>

                                            <span>
                                                {item.label}
                                            </span>

                                        </Link>

                                    )
                                )}

                            </nav>

                        </div>

                    )
                )}

            </div>


            {/* =========================================
                ADMIN PROFILE
            ========================================= */}

            <div className="admin-sidebar-user">

                <div className="admin-user-avatar">
                    A
                </div>

                <div className="admin-user-info">

                    <strong>
                        Administrator
                    </strong>

                    <span>
                        Super Admin
                    </span>

                </div>

                <button
                   style={{ color: "red" }}
                    type="button"
                    title="Logout"
                    onClick={() => {
                        logout();
                        navigate("/admin/login");
                    }}
                >
                    ↪
                </button>

            </div>

        </aside>
    );
};

export default AdminSidebar;

